export default {
  // SOLUTIONS
  'improving_pulmonary_outcomes': {
    heading: 'Improve pulmonary outcomes',
    description: 'Individualized support of pulmonary outcomes based on specific clinical conditions of the patient thanks to frame-based lateral tilt guided by Electrical Impedance Tomography.',
    video: 'multicare/improving_pulmonary_outcomes.mp4'
  },
  'moving_immobile_patient': {
    heading: 'Moving immobile patient',
    description: 'Microshifting, gentle and precise step by step lateral positioning enables adjusting hemodynamically unstable patients while maintaining their spinal alignment.',
    video: 'multicare/moving_immobile_patient.mp4'
  },
  'easier_patient_transfer': {
    heading: 'Easier patient transfer',
    description: 'Frame-based lateral tilt enables easier and smoother patient transfer from Multicare X to a stretcher.',
    video: 'multicare/easier_patient_transfer.mp4'
  },
  'safe_patient_handling': {
    heading: 'Safe patient handling',
    description: 'Frame-based Lateral Tilt makes it easier and safer for nurse to provide daily care while mitigating risk of back injuries.',
    video: 'multicare/safe_patient_handling.mp4'
  },
  'mobilizing_patient_early': {
    heading: 'Mobilize patient early',
    description: 'Lateral tilt allows patient\'s feet to reach the floor easily. The Mobi-Lift handle provides a firm support for the patient during mobilization resulting in a faster recovery.',
    video: 'multicare/mobilizing-patient-early.mp4'
  },

  // KEY FEATURES
  'frame_based_lateral_tilt': {
    heading: 'Frame-based lateral tilt',
    description: 'Unique frame-based lateral tilt has many uses – from making caregivers‘ routine procedures easier and less demanding to improving patient‘s pulmonary outcomes and more. The bed platform can be tilted step by step (microshifting) to both right and left up to 30° angle.',
    images: [
      'multicare/key-features--1-1_1_FRAME_BASED_LATERAL_TILT.jpg',
      'multicare/key-features--1-1_2_FRAME_BASED_LATERAL_TILT.jpg'
    ],
    subExplanations: [
      'automatic_lateral_therapy',
      'lateral_tr_tilt'
    ]
  },
  'automatic_lateral_therapy': {
    heading: 'Automatic lateral therapy',
    description: 'The tilt changes the direction of the applied gravitational force to the lungs. The overdistended lung is more compressed which leads to an increase in ventilation, the collapsed lung is opened which leads again to an increasing in ventilation. Improvement of mechanical ventilation leads to patient recovery.',
    images: [
      'multicare/key-features--1-2_AUTOMATIC_LATERAL_THERAPY.jpg'
    ]
  },
  'lateral_tr_tilt': {
    heading: 'Lateral + (rev)tr tilt (for postural drainage)',
    description: 'Combination of lateral tilt simultaneously with (rev)Trendelenburg Possibility to perform postural drainage and excercise using a bed - reduced staff effort.',
    camera: {
      orbit: '-6.55rad 1.65rad 30%',
      target: '0 0 0'
    },
    images: [
      'multicare/key-features--1-3_LATERAL.jpg',
      'multicare/key-features--1-3_REV_TR_TILT.jpg'
    ]
  },
  'mobilization': {
    heading: 'Mobi-lift',
    description: 'Patient can hold onto and adjust the height of the bed through the Mobi-Lift handle to easily stand up in the last step of mobilisation. Foldable handle with integrated up and down control placed on the side of the bed.',
    camera: {
      orbit: '-0.64rad 1.34rad 30%',
      target: '10m 50m 10m'
    },
    images: [
      'multicare/key-features--2-1_MOBILIFT.jpg',
      'multicare/key-features--2-2_MOBILIFT.jpg'
    ]
  },
  'safety': {
    heading: 'Safety',
    subExplanations: [
      'idrive',
      'ibrake',
      'constant_gap',
      'cpr',
      'bed_exit_alarm',
      'column_design_&_infection_control'
    ]
  },
  'idrive': {
    heading: 'i-Drive power & 5th castor',
    description: 'Battery powered wheel in the middle of the bed allows easy manipulation and transportation of the patient. Controller can be placed on headboard or IV poles Drive automatically stops if the hand is removed 5th castor retractable castor helps to keep the direction of the bed in long corridors and also helps with turning of the bed in narrow spaces.',
    camera: {
      orbit: '-9.73rad 1.31rad 30%',
      target: '-60m 64m 0'
    },
    images: [
      'multicare/key-features--3-1_iDRIVE_POWER___5th_CASTOR_1.jpg',
      'multicare/key-features--3-1_iDRIVE_POWER___5th_CASTOR_2.jpg',
      'multicare/key-features--3-1_iDRIVE_POWER___5th_CASTOR_3.jpg'
    ]
  },
  'ibrake': {
    heading: 'i-Brake',
    description: 'i-Brake automatically engages after 60 seconds of being plugged into electricity providing higher level of patient safety. Neutral position allows easier manipulation of the bed sideways',
    camera: {
      orbit: '-10.43rad 1.47rad 30%',
      target: '0 35m 90m'
    },
    images: [
      'multicare/key-features--3-2_iBRAKE.jpg'
    ]
  },
  'constant_gap': {
    heading: 'Constant gap',
    description: 'Constant safety space between siderails during whole adjustment prevents from both patient and personnel injuries.',
    camera: {
      orbit: '-10.58rad 1.24rad 30%',
      target: '0 auto -20m'
    },
    images: [
      'multicare/key-features--3-3_CONSTANT_GAP.jpg'
    ]
  },
  'cpr': {
    heading: 'CPR',
    description: 'Set of CPR features qucikly repositions bed in critical situations. CPR button – bed flatens, goes into lowest position, active mattress deflates. CPR handle – quickly lowers backrest. CPR valve – deflated Opticare X mattress.',
    camera: {
      orbit: '-11.5rad 1.39rad 10%',
      target: '-35m 45m -80m'
    },
    images: [
      'multicare/key-features--3-4_1_CPR_Button.jpg',
      'multicare/key-features--3-4_2_CPR_HANDLE.jpg',
      'multicare/key-features--3-4_3_CPR_MATTRESS_VALVE.jpg'
    ]
  },
  'bed_exit_alarm': {
    heading: 'Bed exit alarm',
    description: 'Bed Exit Monitoring system monitors patient´s presence in bed and triggers alarms based on defined zone. Inner zone - triggers alarm when patient is moving or going to leave. Outer zone - trigger alarms when patient left the bed.',
    images: [
      'multicare/key-features--3-5_BED_EXIT_ALARM.jpg'
    ]
  },
  'column_design_&_infection_control': {
    heading: 'Column design & infection control',
    description: 'Innovative column solution enables not only frame-based lateral tilt, but also efficient infection control.',
    camera: {
      orbit: '-10.43rad 1.47rad 10%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--3-6-1_COLUMN_DESIGN___INFECTION_CONTROL.jpg',
      'multicare/key-features--3-6-2_COLUMN_DESIGN___INFECTION_CONTROL.jpg'
    ]
  },
  'controls': {
    heading: 'Controls',
    subExplanations: [
      'multiboard_x',
      'foot_controls',
      'attendant_control_panel_acp',
      'patient_controls'
    ]
  },
  'multiboard_x': {
    heading: 'Multiboard x',
    description: 'Large 10" display with nurse-friendly interface provides best reading angle with head of bed placed in the angle of 30°. Being placed in head siderail it allows to maintain visual contact with the patient while controlling the bed designed to mitigate any false touches (for exmaple by IV lines)',
    camera: {
      orbit: '-10.52rad 1.28rad 10%',
      target: '-60m 64m -20m'
    },
    images: [
      'multicare/key-features--4-_1_MULTIBOARD_X.jpg'
    ]
  },
  'foot_controls': {
    heading: 'Foot controls',
    description: 'Foot controls placed on bed undercarriage allowing hands free control of lateral tilt, and high adjustment.',
    camera: {
      orbit: '-10.47rad 1.05rad 10%',
      target: '-25m 0m 0'
    },
    images: [
      'multicare/key-features--4-2_FOOT_CONTROLS.jpg'
    ]
  },
  'attendant_control_panel_acp': {
    heading: 'Attendant control panel (ACP)',
    description: 'Dedicated nurse control panel allows the control the key features from nearby surroundings of the bed.',
    images: [
      'multicare/key-features--4-3ATTENDANT_CONTROL_PANEL_ACP.jpg'
    ]
  },
  'patient_controls': {
    heading: 'Patient controls',
    description: 'Two sets of patient controls are integrated in side rails for optimal ergonomy while sitting or lying, incl. nurse call button. Hand controller provides further comfort to the patient, incl. night light.',
    camera: {
      orbit: '-5.16rad 1.22rad 10%',
      target: '-75m 75m 0'
    },
    images: [
      'multicare/key-features--4-4_1_PATIENT_CONTROLS.jpg',
      'multicare/key-features--4-4_2_PATIENT_CONTROLS.jpg'
    ]
  },
  'comfort': {
    heading: 'Comfort',
    subExplanations: [
      'usb_charger',
      'x-ray_cassette_holder',
      'ergoframe',
      'electrical_bed_extension',
      'positioning'
    ]
  },
  'usb_charger': {
    heading: 'USB Charger',
    description: 'USB charger socket placed in inner side of head side rails for convenient charging of devices.',
    camera: {
      orbit: '-11.06rad 1.30rad 10%',
      target: '-115m 85m -70m'
    },
    images: [
      'multicare/key-features--5-1_USB_CHARGER.jpg'
    ]
  },
  'x-ray_cassette_holder': {
    heading: 'X-RAY Cassette holder',
    description: 'X-ray cassette holder is integrated under the bed frame and allows easy cassette insertion, adjustment and removal.',
    camera: {
      orbit: '-10.60rad 1.26rad 10%',
      target: '-55m 35m 5m'
    },
    images: [
      'multicare/key-features--5-2_XRAY_CASSETTE_HOLDER.jpg'
    ]
  },
  'ergoframe': {
    heading: 'Ergoframe',
    description: 'System causing enlargement of the space between the back and thigh part during their positioning for prevention of preassure injuries.',
    images: [
      'multicare/key-features--5-4_ERGOFRAME.jpg'
    ]
  },
  'electrical_bed_extension': {
    heading: 'Electrical bed extension',
    description: 'One button electric function ensures quick and easy bed extension.',
    camera: {
      orbit: '-11.85rad 1.44rad 50%',
      target: '0m 55m 20m'
    },
    images: [
      'multicare/key-features--5-3_ELECTRICAL_BED_EXTENSION.jpg'
    ]
  },
  'positioning': {
    heading: 'Positioning',
    description: 'Using Multiboard X, foot controls or nurse control panel the bed can be easily repositioned to any of the standard or advanced position. For the key position one-button positioning function is available. Backrest stops automatically at 30° and 45° angle.',
    images: [
      'multicare/key-features--5-5_POSITIONING_1.jpg',
      'multicare/key-features--5-5_POSITIONING_2.jpg',
      'multicare/key-features--5-5_POSITIONING_3.jpg',
      'multicare/key-features--5-5_POSITIONING_4.jpg',
      'multicare/key-features--5-5_POSITIONING_5.jpg',
      'multicare/key-features--5-5_POSITIONING_6.jpg',
      'multicare/key-features--5-5_POSITIONING_7.jpg',
      'multicare/key-features--5-5_POSITIONING_8.jpg',
      'multicare/key-features--5-5_POSITIONING_9.jpg',
      'multicare/key-features--5-5_POSITIONING_10.jpg'
    ]
  },
  'opticare_x': {
    heading: 'Opticare x',
    subExplanations: [
      'multiboard_x_mattress_screen',
      'microclimate_management',
      'bottoming_out_detection',
      'mattress_modes',
      'x-ray_sleeve',
      'cpr_valve_cpr_button',
      'zoned_cover',
      'automatic_foot_extension'
    ]
  },
  'multiboard_x_mattress_screen': {
    heading: 'Multiboard x mattress screen',
    description: 'Thanks to full integration, the mattress can be also controled from Multibaord X, allowing to make all the necessary adjustments from single place.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-1_MULTIBOARD_X_MATTTRESS_SCREEN.jpg'
    ]
  },
  'microclimate_management': {
    heading: 'Microclimate management',
    description: 'Opticare X helps maintain the natural thermoregulation by circulating air through the mattress surface. It helps to maintain healthy heat and moisture levels at the patient’s skin.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-2-_MICROCLIMATE_MANAGEMENT.jpg'
    ]
  },
  'bottoming_out_detection': {
    heading: 'Bottoming out detection',
    description: 'Patented technology of bottoming out detection (BOD) continuously checks the level of immersion of the patient and in case of imminent risk of bottoming out automatically and immediatelly increases the air pressure to support safety and provide higher comfort for the patient.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-3-_Bottoming_out.jpg'
    ]
  },
  'mattress_modes': {
    heading: 'Mattress modes',
    description: 'Wide ranage of available mattress modes allows the optimal setting of the surface for specific clinical conditions: Optimize Mode for optimal immersion. Prone Mode providing balance between pressure redistribution and stability for the patients being nursed in the prone position',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-4-_MATTRESS_MODES.jpg'
    ]
  },
  'x-ray_sleeve': {
    heading: 'X-RAY Sleeve',
    description: 'For easier X-ray procedure and wide variety of cassettes.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-5-_XRAY_SLEEVE.jpg'
    ]
  },
  'cpr_valve_cpr_button': {
    heading: 'CPR Valve / CPR Button',
    description: 'CPR valve deflates the mattress quickly, while CPR electrical button additionally flattens and lowers the bed, allowing immediate chest compressions.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-6-_CPR_VALVE_CPR_BUTTON.jpg'
    ]
  },
  'zoned_cover': {
    heading: 'Zoned cover',
    description: 'Dartex® Zoned Coating by Trelleborg technology exclusively designed for LINET provides different fabric functionality in the sides (grippy) versus the centre of the cover (slippy) to perform multiple functions.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-8-_ZONED_COVER.jpg'
    ]
  },
  'automatic_foot_extension': {
    heading: 'Automatic foot extension',
    description: 'The heel section of the mattress can be automatically adjusted when the bed frame is extended.',
    camera: {
      orbit: '-8.58rad 0.84rad 100%',
      target: '0 35m 70m'
    },
    images: [
      'multicare/key-features--6-9-_AUTOMATIC_FOOT_EXTENSION.jpg'
    ]
  },
  'accessories': {
    heading: 'Accessories',
    subExplanations: [
      'foldable_iv_&_drive_poles',
      'protectors',
      'stabilisation_kit',
      'oxygen_bottle_holder',
      'ventilator_circuit_holder',
      'iv_poles',
      'urine_sack_holder'
    ]
  },
  'foldable_iv_&_drive_poles': {
    heading: 'Foldable IV & Drive poles',
    description: 'Infusion stand and handles (attachable on bed frame under head end) with i-Drive Power controller holder.',
    camera: {
      orbit: '-8.80rad 1.41rad 50%',
      target: '0m 55m 20m'
    },
    images: [
      'multicare/key-features--7-1_FOLDABLE_IV___DRIVE_POLES.jpg'
    ]
  },
  'protectors': {
    heading: 'Protectors',
    description: 'Complete set of protectors with cover for Multicare X.',
    images: [
      'multicare/key-features--7-2_PROTECTORS.jpg'
    ]
  },
  'stabilisation_kit': {
    heading: 'Stabilisation kit',
    description: 'Set of foam frame pads and perl balls fixation pillows for fixation of the patient during lateral tilt or Automatic Lateral Therapy.',
    images: [
      'multicare/key-features--7-3_STABILISATION_KIT.jpg'
    ]
  },
  'oxygen_bottle_holder': {
    heading: 'Oxygen bottle holder',
    description: 'Various oxygen bottle holders for bed end allowing easier transportation.',
    images: [
      'multicare/key-features--7-4-A_OXYGEN_BOTTLE_HOLDER.jpg',
      'multicare/key-features--7-4-B_OXYGEN_BOTTLE_HOLDER.jpg'
    ]
  },
  'ventilator_circuit_holder': {
    heading: 'Ventilator circuit holder',
    description: 'Ventilator circuit holder allowing easier and safer set up of the tubes during mechanical ventilation.',
    images: [
      'multicare/key-features--7-5-_VENTILATOR_CIRCUIT_HOLDER.jpg'
    ]
  },
  'iv_poles': {
    heading: 'IV Poles',
    description: 'IV poles for infusion bags attachable at head end.',
    images: [
      'multicare/key-features--7-6-_IV_POLES_with_plastic_box.jpg'
    ]
  },
  'urine_sack_holder': {
    heading: 'Urine sack holder',
    description: 'Various urine/drainage sack holders for undercarriage.',
    images: [
      'multicare/key-features--7-7_1_URINE_SACK_HOLDER_Urine_bottle,_shoes_holder_with_2_hooks.jpg',
      'multicare/key-features--7-7_2_URINE_SACK_HOLDER_Urine_sack_holder_for_undercarriage.jpg',
      'multicare/key-features--7-7_3_URINE_SACK_HOLDER.jpg'
    ]
  }
}
